import React from 'react'
import Modal from 'components/modal'
import 'less/custom-crowd-thank-you.less'

const CustomCrowdThankYouModal = (props) => (
  // @ts-ignore
  <Modal
    isOpen
    className="custom-crowd-thank-you"
    cancelBtnText="Return to Dashboard"
    submittable={false}
    onCancel={() => props.onCancel()}
  >
    <h2>Thank You!</h2>
    <p>Someone from our team will get in touch with you as soon as we've</p>
    <p>reviewed your custom crowd. In the meantime if you have questions you</p>
    <p>can give us a call at <span><a href="tel:617-934-1600">(617) 934-1600</a></span> or email us at <a href="mailto:qual@incrowdnow.com">qual@incrowdnow.com</a></p>
  </Modal>
)

export default CustomCrowdThankYouModal
